import invariant from 'tiny-invariant';

import { useRestApiHeaders } from 'business/contextProviders/useApiHeaders';
import { useAppContext } from 'business/contextProviders/useAppContext';
import { useScanConfigV1ControllerGetByConstructionSite } from 'generated/apiComponents';
import { Module_Enum } from 'generated/graphql';

export const useGetScanConfigData = () => {
  const { currentConstructionSiteId } = useAppContext();
  invariant(currentConstructionSiteId, 'No construction site');

  const restHeaders = useRestApiHeaders(Module_Enum.QualityScan);

  const { data, error, isLoading } =
    useScanConfigV1ControllerGetByConstructionSite({
      queryParams: {
        constructionSiteId: currentConstructionSiteId,
      },
      headers: restHeaders,
    });

  return {
    data,
    loading: isLoading,
    error,
  };
};
